import { createSelector, createSelectorCreator, defaultMemoize, } from 'reselect';
import { isProduction } from './version';
/**
 * @function
 * @return boolean
 * Предикат, который умеет сравнивать 2 массива из объектов
 * FEATURE: ТОЛЬКО по нужным полям
 * нельзя использовать lodash.isEqual, т.к. теряем фичу сравнения только нужных полей
 */
const compareArrayByFields = (fields) => (first_array_of_objects, second_array_of_objects) => {
    //Сравниваем ссылки на массивы
    if (first_array_of_objects === second_array_of_objects) {
        return true;
    }
    //Сравниваем массивы по длине
    if (first_array_of_objects.length !== second_array_of_objects.length) {
        return false;
    }
    //Перебираем все объекты массивов
    for (let i = 0; i < first_array_of_objects.length; i++) {
        const ai = first_array_of_objects[i];
        const bi = second_array_of_objects[i];
        //Сравнили по ссылкам
        if (ai === bi) {
            continue;
        }
        //Пошли сравнивать по НУЖНЫМ полям
        for (const field of fields) {
            if (ai[field] !== bi[field]) {
                return false;
            }
        }
    }
    return true;
};
/**
 * @function
 * @return function
 * Добавили дополнительную мемоизацию, чтобы отбросить сравнение ненужных полей.
 */
const memoizedArrayByObjectFieldsSelector = (fields) => createSelectorCreator(defaultMemoize, compareArrayByFields(fields));
/**
 * @function
 * @return function
 * Возвращаем мемоизированный селектор,
 * который принимает массив ключей и ВОЗВРАЩАЕТ массив из объектов с запрашиваемыми ключами
 * Returns the function that takes an array and returns array of stripped items with only requested fields
 */
export const selectStripItemsOfArray = (fields) => 
// @ts-ignore return another type in production mode
memoizedArrayByObjectFieldsSelector(fields)((array) => array, isProduction()
    ? // In production mode just return the same array with all fields for the sake of speed.
        // But comparison function will enforce memoization if none of requested fields
        // were changed.
        (array) => array
    : // In development mode do strict subsetting to ensure we won't rely on any fields
        // beyond explicitly requested.
        (array) => {
            const result = [];
            for (const item of array) {
                const subset = {};
                for (const field of fields) {
                    if (field in item) {
                        subset[field] = item[field];
                    }
                }
                result.push(subset);
            }
            return result;
        });
/**
 * @function
 * @return function
 * Возвращаем мемоизированный селектор (обновление только по нужным ключам),
 * который принимает массив ключей и ВОЗВРАЩАЕТ объект с запрашиваемыми ключами.
 * ВНИМАНИЕ!
 * т.к. селектор создаёт кэш размера 1, нельзя использовать эту функцию в компонентах,
 * которые больше 1 раза одновременно появляются на экране
 * Кодовые слова: device.iconState - почему вынимаем и считаем в самом начале?
 */
export const createSubsetSelector = (fields) => createSelector(
//  приняли объект (любой), проверили, что он не null
(obj) => obj != null, 
// теперь приняли все поля, которые нужны из этого объекта
...fields.map((field) => (obj) => obj?.[field]), (non_null, ...values) => {
    if (!non_null) {
        return null;
    }
    const result = {};
    for (let i = 0; i < fields.length; i++) {
        result[fields[i]] = values[i];
    }
    return result;
}
//FIXME: 31.03.2023 Selector unknown generic type https://github.com/reduxjs/reselect/issues/571
);
